import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMockups, setSelectedMockup } from "../../../Store/reducers/mockupCategorySlice.js";
import AppConfig from "../../../config/AppConfig";
import mright from "../../../assets/icons/icon-mright.svg";
import {observe} from "react-intersection-observer";

const FullCategoryMockups = ({ categoryId, setSelectedCategory,selectedColor }) => {
    const dispatch = useDispatch();
    const selectedCategory = useSelector((state) =>
        state.mockupCategories.Mockups.find((cat) => cat.id === categoryId) 
    );


    const observerRef = useRef(null);

    useEffect(() => {
        console.log("Category updated:", selectedCategory);
    }, [selectedCategory]);

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(2);
    // Use a separate ref for the sentinel element
    const sentinelRef = useRef(null);


    useEffect(() => {
        if (selectedCategory.nextPageUrl || (selectedCategory.mockups.length>2&& !loading)) {
            setLoading(true);
            dispatch(fetchMockups({ page: currentPage, categoryId: selectedCategory.id }))
                .then(() => {
                    setCurrentPage(1);
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }
    }, [selectedCategory]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting && !loading) {
                    setLoading(true);
                    setCurrentPage((prev) => prev + 1);
                }
            },
            { threshold: 1.0 }
        );

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, []);

    const filteredMockups = selectedColor
    ? selectedCategory.mockups.filter((m) => m.color_id === selectedColor)
    : selectedCategory.mockups;

    const handleAddMockupToCanvas = (item) => {
        const { storageUrl } = AppConfig;
        const selectedMockup = {
            design_layer: `${storageUrl}/${item.mockup}`,
            glb_layer: `${storageUrl}/${item.glb_layer}`,
            mask_layer: `${storageUrl}/${item.design_layer}`,
            height: item.height,
            width: item.width,
            ...(item.shadow_layer != null && { shadow_layer: `${storageUrl}/${item.shadow_layer}` }),
            ...(item.additional_layer != null && { additional_layer: `${storageUrl}/${item.additional_layer}` }),
            logoDefaultSize: item.default_size,
            logoMinSize: item.min_size,
            logoMaxSize: item.max_size,
            logoBoundaryX1: item.boundary_x1,
            logoBoundaryX2: item.boundary_x2,
            logoBoundaryY1: item.boundary_y1,
            logoBoundaryY2: item.boundary_y2,
        };
        dispatch(setSelectedMockup(selectedMockup));
    };

    return (
        <>
            <div className="flex items-center gap-2">
                <img
                    src={mright}
                    alt="Back Icon"
                    className="w-[20px] h-[20px] cursor-pointer rotate-180"
                    onClick={() => setSelectedCategory(null)}
                />
                <h3 className="font-semibold text-black font-montserrat text-[12px] leading-[12.19px]">
                    {selectedCategory.title}
                </h3>
            </div>
            <div className="h-[340px] overflow-y-scroll custom-scrollbar px-2" ref={observerRef}>
                <div className="mockups-grid grid grid-cols-2 gap-2 p-2">
                    {filteredMockups .map((item, index) => (
                        <div className="relative">
                        <img
                            onClick={() => handleAddMockupToCanvas(item)} 
                            key={index}
                            src={`${AppConfig.storageUrl}/${item.thumbnail}`}
                            className="w-[90px] h-[90px] object-cover"
                            draggable
                            alt=""
                        />
                          {item.is_premium === 1 && (
                <img
                  src="https://www.svgrepo.com/download/1195/premium-badge.svg"
                  alt="Premium"
                  className="absolute top-0 right-3 w-4 h-4"
                />
              )}
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default FullCategoryMockups;
